import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = { class: "p-field p-mr-1" }
const _hoisted_3 = { class: "p-inputgroup p-inputtext-sm" }
const _hoisted_4 = { class: "p-field p-ml-1" }
const _hoisted_5 = { class: "p-inputgroup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.filter.label), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_dropdown, {
            class: "p-inputtext-sm",
            modelValue: _ctx.selectedMin,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMin) = $event)),
            modelModifiers: { lazy: true, number: true },
            placeholder: "Min",
            options: _ctx.minOptions,
            optionLabel: "name",
            optionValue: "num",
            optionDisabled: "disabled",
            editable: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_dropdown, {
            class: "p-inputtext-sm",
            modelValue: _ctx.selectedMax,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMax) = $event)),
            modelModifiers: { lazy: true, number: true },
            placeholder: "Max",
            options: _ctx.maxOptions,
            optionLabel: "name",
            optionValue: "num",
            optionDisabled: "disabled",
            editable: ""
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ])
  ]))
}